import { Pipe, PipeTransform } from '@angular/core';
import { INDRAIbeAdminConfigService } from './ibeadmin-config.service';

@Pipe({
	name: 'ibeadmincfg'
})
export class INDRAIbeAdminConfigPipe implements PipeTransform {

	constructor(private ibeAdminService: INDRAIbeAdminConfigService) { }

	transform(value: string): any {
		if (value) {
			return this.ibeAdminService.getConfigurationValue(value);
		}
	}
}
